/**
 * Helper for downloading files with axios
 *
 * Usage: route(data, filename);
 * Example: route(response.data, 'certificate.xlsx');
 */

export default (data, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
        var blobObject = new Blob([data]);
        window.navigator.msSaveOrOpenBlob(blobObject, filename);
    } else {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }
};
